import { useDispatch } from 'react-redux';
import { triggerMigration } from '@fedsim/actions';

import { migrations } from "./migrations"

export function useMigration() {
  const dispatch = useDispatch()

  const onRunMigrations = () => {
    migrations.forEach(migration => {
      dispatch(
        triggerMigration(migration)
      )
    })
  }
  const onRunMigration = (migration) => dispatch(triggerMigration(migration))


  return {
    onRunMigrations,
    onRunMigration
  }
}
